/**
 * guards/AdminRoute.jsx
 * Allows only admin. Redirects everyone else appropriately.
 */
import { Navigate } from "react-router-dom";

export default function AdminRoute({ user, role, children }) {
  if (!user) return <Navigate to="/" replace />;
  if (role === "admin") return children;
  if (role === "mentor") return <Navigate to="/mentordashboard" replace />;
  return <Navigate to="/dashboard" replace />;
}